import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import '../stylesheet/ErrorPage.css';

class ErrorPage extends Component {
    constructor(props) {
        super(props);
        this.state = { x: 0, y: 0 };
    }

    _onMouseMove(e) {
        this.setState({ x: e.screenX, y: e.screenY });
    }

    render() {
        const { x, y } = this.state;
        return (
            <div className="base">
                <div id="container-error" onMouseMove={this._onMouseMove.bind(this)} style={{backgroundPositionX:-x/5, backgroundPositionY:-y/5}}>
                    <div className="content-error">
                        <h2>4O4</h2>
                        <h4>Oops! Page not found</h4>
                        <p>The page you were looking for doesn't exist. You may have mistyped the address or the page may have moved.</p>
                        <Link className="back" to="/">Back To Home</Link>
                    </div>
                </div>
            </div>
        )
    }
}

export default ErrorPage;
